import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_80vt7ytsru: FaireBrandEntity = {
  token: "b_80vt7ytsru",
  type: "brand",
  name: "gentle thrills",
  avatarUrl:
    "https://cdn.faire.com/fastly/32544a44e982fcc7f0047a0b399c40a27727dd51a8ca0c15c24b6048b29d4c56.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1c2ef042a72591b2b53c6227e6eb19c3d1457483f47b5c411da001e765f93b71.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/32544a44e982fcc7f0047a0b399c40a27727dd51a8ca0c15c24b6048b29d4c56.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1c2ef042a72591b2b53c6227e6eb19c3d1457483f47b5c411da001e765f93b71.jpeg",
  location: "los angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 67,
  isTopShop: true,
  isInsider: true,
  description:
    "originally established in 2015 in a 100 square foot studio in los angeles, california, gentle thrills is a playful, colorful, and vintage-inspired retail line designed in limited editions by artist isa beniston.\n\nonce described by nashville scene as “fairly well-known,” gentle thrills has expanded its studio as well as its range of products to include affordable smalls like cards, stickers, hair accessories, matches, and other throwback giftables, always with a focus on standing out in a crowd!",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:04.070Z",
    importedBy: "entity-db-cli",
  },
};
